import { useState } from 'react'
import { supabase } from '../supabaseClient'
import { localDateString } from '../utils/date'

const BEHAVIORS = [
  { id: 'alcohol', label: 'Alcohol' },
  { id: 'drugs', label: 'Drugs' },
  { id: 'porn', label: 'Porn' },
  { id: 'smoking', label: 'Smoking' },
  { id: 'gambling', label: 'Gambling' },
  { id: 'nails', label: 'Nail Biting' },
  { id: 'social_media', label: 'Social Media' },
  { id: 'skin_picking', label: 'Skin Picking' },
]

export default function Settings({ session, currentBehavior, onUpdate, onClose }) {
  const [selected, setSelected] = useState(currentBehavior)
  const [loading, setLoading] = useState(false)
  const [saved, setSaved] = useState(false)
  const [confirming, setConfirming] = useState(false)

  async function handleSave() {
    if (selected === currentBehavior) {
      onClose()
      return
    }
    setConfirming(true)
  }

  async function handleConfirm() {
    setLoading(true)
    const today = localDateString()

    await supabase
      .from('profiles')
      .update({ behavior: selected })
      .eq('id', session.user.id)

    await supabase
      .from('streaks')
      .update({ is_active: false })
      .eq('user_id', session.user.id)
      .eq('is_active', true)

    await supabase.from('streaks').insert({
      user_id: session.user.id,
      behavior: selected,
      start_date: today,
      days_count: 0,
      is_active: true,
    })

    setSaved(true)
    setLoading(false)
    setTimeout(() => {
      onUpdate(selected)
      onClose()
    }, 1000)
  }

  async function handleSignOut() {
    await supabase.auth.signOut()
  }

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h2 style={styles.title}>Settings</h2>
          <button onClick={onClose} style={styles.closeBtn}>✕</button>
        </div>

        <p style={styles.label}>Change what you're working on:</p>

        <div style={styles.grid}>
          {BEHAVIORS.map(b => (
            <button
              key={b.id}
              onClick={() => setSelected(b.id)}
              style={{
                ...styles.btn,
                border: selected === b.id
                  ? '2px solid #7c3aed'
                  : '2px solid rgba(255,255,255,0.08)',
                background: selected === b.id
                  ? 'rgba(124,58,237,0.15)'
                  : 'rgba(255,255,255,0.04)',
              }}
            >
              <span style={styles.btnLabel}>{b.label}</span>
            </button>
          ))}
        </div>

        {saved ? (
          <div style={styles.savedMsg}>
            <p style={{ color: '#4ade80', margin: 0, fontWeight: 700 }}>
              ✅ Updated! Starting fresh streak.
            </p>
          </div>
        ) : confirming ? (
          <div>
            <p style={{ color: '#fca5a5', fontSize: 13, textAlign: 'center', marginBottom: 12 }}>
              ⚠️ Switching will reset your current streak. Are you sure?
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
              <button
                style={{ ...styles.saveBtn, background: 'rgba(255,255,255,0.06)' }}
                onClick={() => setConfirming(false)}
              >
                Cancel
              </button>
              <button
                style={styles.saveBtn}
                onClick={handleConfirm}
                disabled={loading}
              >
                {loading ? 'Saving...' : 'Yes, switch'}
              </button>
            </div>
          </div>
        ) : (
          <button
            style={styles.saveBtn}
            onClick={handleSave}
            disabled={loading}
          >
            Save Changes
          </button>
        )}

        <button style={styles.signOutBtn} onClick={handleSignOut}>
          Sign Out
        </button>
      </div>
    </div>
  )
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    zIndex: 100,
  },
  card: {
    width: '100%',
    maxWidth: 380,
    background: 'linear-gradient(145deg, #1a1040, #0d0d1a)',
    border: '1px solid rgba(167,139,250,0.3)',
    borderRadius: 24,
    padding: 32,
    position: 'relative',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
  },
  title: {
    color: '#fff',
    fontFamily: 'serif',
    fontSize: 22,
    margin: 0,
  },
  closeBtn: {
    background: 'none',
    border: 'none',
    color: 'rgba(255,255,255,0.4)',
    fontSize: 18,
    cursor: 'pointer',
  },
  label: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 13,
    marginBottom: 16,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
    marginBottom: 24,
  },
  btn: {
    padding: '16px 12px',
    borderRadius: 14,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
  },
  btnLabel: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 600,
  },
  saveBtn: {
    width: '100%',
    padding: 14,
    background: 'linear-gradient(135deg, #7c3aed, #2563eb)',
    border: 'none',
    borderRadius: 12,
    color: '#fff',
    fontSize: 15,
    fontWeight: 700,
    cursor: 'pointer',
    marginBottom: 12,
  },
  savedMsg: {
    textAlign: 'center',
    padding: 14,
    marginBottom: 12,
  },
  signOutBtn: {
    width: '100%',
    padding: 14,
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 12,
    color: 'rgba(255,255,255,0.4)',
    fontSize: 14,
    cursor: 'pointer',
  },
}